import { v4 } from 'uuid';

const createOptimisticComment = (user, content, resourceId) => {
  const optimisticId = v4();
  return {
    id: optimisticId,
    isDraft: true,
    content,
    draftId: optimisticId,
    createdAt: (/* @__PURE__ */ new Date()).toISOString(),
    modifiedAt: (/* @__PURE__ */ new Date()).toISOString(),
    user,
    resourceId,
    annotation: {}
  };
};

export { createOptimisticComment };
//# sourceMappingURL=createOptimisticComment.js.map
